import { render, staticRenderFns } from "./ScheduledOcr.vue?vue&type=template&id=460a7f8a&scoped=true&"
import script from "./ScheduledOcr.vue?vue&type=script&lang=js&"
export * from "./ScheduledOcr.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledOcr.vue?vue&type=style&index=0&id=460a7f8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a7f8a",
  null
  
)

export default component.exports